import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "efficiency",
})
export class EfficiencyPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let effeciency;
    if (value.total) {
      effeciency = Math.floor((value.solved / value.total) * 100);
      effeciency = effeciency + " %";
    } else {
      effeciency = "0 %";
    }

    return effeciency;
  }
}
